import '../../css/blocks/contact-persons.css';

// Wait for the window to fully load before initializing
window.addEventListener('load', () => {
  const contactPersonsBlocks = document.querySelectorAll('.contact-persons');
  
  if (contactPersonsBlocks.length) {
    // Initialize block-specific functionality here
  }
});
